import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { EMPTY_PLACEHOLDER } from './commonUtils';

// ============================================================================
// Reusable Typography Styles
// ============================================================================

/** Label style: Montserrat, SemiBold, 16px, 100% line-height */
export const LABEL_SX: SxProps<Theme> = {
  fontFamily: 'Montserrat, sans-serif',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: 1,
  color: '#101828',
  mb: 0.5,
};

/** Body style: Nunito, Regular, 16px, 145% line-height, capitalize */
export const BODY_SX: SxProps<Theme> = {
  fontFamily: 'Nunito, sans-serif',
  fontWeight: 400,
  fontSize: 16,
  lineHeight: 1.45,
  textTransform: 'capitalize',
  color: '#475467',
};

/** Body style with pre-wrap for multiline text */
export const BODY_MULTILINE_SX: SxProps<Theme> = {
  ...BODY_SX,
  whiteSpace: 'pre-wrap',
};

// ============================================================================
// Reusable Table Styles
// ============================================================================

/** Table header row style: sticky, gray background, Montserrat Medium 14px */
export const TABLE_HEADER_ROW_SX: SxProps<Theme> = {
  position: 'sticky',
  top: 0,
  zIndex: 1,
  borderRadius: '8px',
  background: '#F5F6F7',
  '& .MuiTableCell-root': {
    borderBottom: 'none',
    background: '#F5F6F7',
    whiteSpace: 'nowrap',
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '20px',
    color: '#667085',
    py: 1.5,
  },
};

export const TABLE_PLACEHOLDER_SX: SxProps<Theme> = {
  width: '100%',
  textAlign: 'center',
  color: 'text.disabled',
};

export const renderTablePlaceholder = () =>
  React.createElement(Box, { sx: TABLE_PLACEHOLDER_SX }, EMPTY_PLACEHOLDER);

// ============================================================================
// Reusable Button Styles
// ============================================================================

/** Outlined gray button style: used for secondary actions like Back, Save Draft, etc. */
export const outlinedGrayButtonSx: SxProps<Theme> = {
  fontWeight: 600,
  borderColor: '#bdbdbd',
  color: '#616161',
  '&:hover': {
    borderColor: '#9e9e9e',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};
